<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-bind:style="{'z-index': '4'}" class="layout-row pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1"
                  :disabled="tableObj.loading"
                  @click="getDataForTable()"
                  icon="refresh"
                  :tooltip="$t('LIST_DIVERSE.REFRESH')"
                  label="Aktualisieren"
                  hide-label></lx-btn>
        </div>

        <div class="flex layout-row mr-1 ml-3">
          <lx-search-field
            :placeholder="$t('MONITORING.USER_LIST.TABLE.SEARCH_PLACEHOLDER')"
            dense
            v-model="tableObj.filterValue"
            :data-method="getDataForTable"
          ></lx-search-field>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden;">

        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;"
             :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="UsersList"
              :items="items"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              preventRowClick
              :tableOptions="tableObj.options"
              hideContextFilter
              @changeOptions="changeTableOptions">

              <template #cellrenderer="{ value }">
                <div v-if="value.f.renderer === 'checkbox'" style="height:35px;" class="layout-column layout-align-center-center">
                  <v-simple-checkbox :dark="compColor.isInDarkMode"
                                     :color="compColor.primeColor"
                                     disabled
                                     v-model="value.i.is_active"></v-simple-checkbox>
                </div>

                <div v-if="value.f.renderer === 'roles'" class="layout-align-center-start">
                  <span>{{ formatRoles(value.i.roles) }}</span>
                </div>

                <div v-if="value.f.renderer === 'dateTime'" class="layout-align-center-start">
                  <span v-if="value.i.last_login">{{ $options.filters['formatDate'](value.i.last_login, 'DD.MM.YYYY') }}
                    <small> {{ $options.filters['formatDate'](value.i.last_login, 'HH:mm') }} {{ $t('MONITORING.USER_LIST.TABLE.CLOCK') }}</small>
                  </span>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'MonitoringUsersList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LxPagination from '../../../components/lx_pagination/LxPagination'
import utils from "../../../common/utils"

export default {
  name: 'MonitoringUsersList',
  mixins: [utils],
  components: {
    LxPagination
  },
  data () {
    return {
      tableObj: {
        loading: false,
        options: {
          sortBy: ['lastname'],
          sortDesc: [false],
        },
        filterValue: null,
        headers: [
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.LASTNAME'),
            value: 'lastname',
            width: '170px',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.FIRSTNAME'),
            value: 'firstname',
            width: '150px',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.EMAIL'),
            value: 'email',
            width: '200px',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.LOGIN'),
            value: 'login',
            width: '150px',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.FRONTEND_VERSION'),
            value: 'frontend_version',
            width: '100px',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.BROWSER'),
            value: 'browser',
            width: '150px',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.OS'),
            value: 'os',
            width: '100px',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.ROLES'),
            value: 'roles',
            width: '200px',
            renderer: 'roles'
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.LAST_LOGIN'),
            value: 'last_login',
            width: '130px',
            renderer: 'dateTime',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.REGISTER_DATE'),
            value: 'register_date',
            width: '100px',
            renderer: 'date',
            sortable: true
          },
          {
            text: this.$t('MONITORING.USER_LIST.TABLE.IS_ACTIVE'),
            value: 'is_active',
            bodyClass: 'text-center',
            class: 'text-center',
            width: '50px',
            renderer: 'checkbox',
            sortable: true
          }
        ]
      },
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      items: []
    }
  },
  created () {
    this.getDataForTable()
  },
  methods: {
    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * get list of all users
     */
    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      // set search value only if filter value has content, else clear filter value (e.g. string has only spaces)
      if (this.tableObj.filterValue && this.tableObj.filterValue.replace(/\s/g, '').length > 0) {
        query.search = this.clearStringForRegexSearch(this.tableObj.filterValue)
      } else {
        this.tableObj.filterValue = null
      }

      this.$http.get('monitoring/users', { config: { opts: opts, query: query } })
        .then(res => {
          if (res.data) {
            this.items = res.data.items || []
            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    formatRoles (roles) {
      if (Array.isArray(roles) && roles.length > 0) {
        let result = []
        for (let i = 0; i < roles.length; i++) {
          if (roles[i] !== 'users') {
            result.push(this.$t('MONITORING.USER_LIST.ROLES.' + roles[i]))
          }
        }
        return result.sort().join(', ')
      }
      return ''
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'MonitoringUsersList') {
        this.getDataForTable()
      }
    }
  }
}
</script>
